module.exports = __webpack_public_path__ + "static/img/013.c43f3079.jpg";